// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unread-message-marker {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
}

.unread-marker-line {
  flex-grow: 1;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.12);
}

.unread-marker-label {
  padding: 4px 12px;
  font-size: 12px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  text-transform: uppercase;
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .unread-marker-line {
    height: 2px;
  }

  .unread-marker-label {
    font-weight: 900;
  }
}

/* Responsive design - adjust padding on smaller screens */
@media (max-width: 768px) {
  .unread-message-marker {
    padding: 8px 15px;
  }

  .unread-marker-label {
    font-size: 11px;
    padding: 0 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/UnreadMessageMarker.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":[".unread-message-marker {\n  display: flex;\n  align-items: center;\n  padding: 10px 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.unread-marker-line {\n  flex-grow: 1;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.12);\n}\n\n.unread-marker-label {\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.6);\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 12px;\n  text-transform: uppercase;\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .unread-marker-line {\n    height: 2px;\n  }\n\n  .unread-marker-label {\n    font-weight: 900;\n  }\n}\n\n/* Responsive design - adjust padding on smaller screens */\n@media (max-width: 768px) {\n  .unread-message-marker {\n    padding: 8px 15px;\n  }\n\n  .unread-marker-label {\n    font-size: 11px;\n    padding: 0 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
